module.exports = __webpack_public_path__ + "static/media/grabaseat4.475a4a0b.jpg";